import dayjs from "dayjs";

export const dateTimeCell = (value, spanClassName = '') => {
	return <span className={spanClassName}>{value ? dayjs(value).format('DD-MM-YYYY HH:mm') : 'N/A'}</span>
}